import { createDomain, createEvent, sample } from "effector";
import { createDialog } from "../../shared/libs/dialog-factory";
import { viewerEntity } from "../../shared/entities/viewer";
import { UserSettings } from "../../shared/entities/viewer/api";

const domain = createDomain();

const dialog = createDialog({
  domain,
});

const submit = createEvent<UserSettings>();

const { updateUserSettingsFx, $currentSimilarity } = viewerEntity;

sample({
  clock: updateUserSettingsFx.doneData,
  target: dialog.close,
});

sample({
  clock: submit,
  target: updateUserSettingsFx,
});

export const setSimilarityFilterModel = {
  dialog,
  opened: dialog.$opened,
  open: dialog.open,
  close: dialog.close,
  $currentSimilarity,
  submit,
};
